import { Typography, styled } from '@mui/material';

export const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(6),
  color: theme.palette.primary.main,
}));
